import { render, staticRenderFns } from "./DesignPanelNw.vue?vue&type=template&id=56c61348&scoped=true"
import script from "./DesignPanelNw.vue?vue&type=script&lang=js"
export * from "./DesignPanelNw.vue?vue&type=script&lang=js"
import style0 from "./DesignPanelNw.vue?vue&type=style&index=0&id=56c61348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c61348",
  null
  
)

export default component.exports